import { render, staticRenderFns } from "./DexMobileModal.vue?vue&type=template&id=4220e551&scoped=true"
import script from "./DexMobileModal.vue?vue&type=script&lang=ts"
export * from "./DexMobileModal.vue?vue&type=script&lang=ts"
import style0 from "./DexMobileModal.vue?vue&type=style&index=0&id=4220e551&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4220e551",
  null
  
)

export default component.exports